/* eslint-disable indent */
import { createExportHandlers } from '@src/main/modules/messages/utils/createExportHandlers';
import { normalizePunctualityReport } from '@src/main/modules/messages/utils/formatters';
import {
  FormExcelItemDto,
  PunctualityDetail,
} from '@src/main/modules/reports/shared/domain/report.interface';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const usePunctualityExport = (
  detailedReports: PunctualityDetail[],
  formType: string,
  fileName: string,
) => {
  const { t } = useTranslation();

  return useMemo(() => {
    const itemTitles =
      formType === 'NB'
        ? detailedReports
            .flatMap((form) => form.items)
            .filter((item, index, self) => self.findIndex((t) => t.title === item.title) === index)
            .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
            .map((item) => item.title)
        : (() => {
            const allItems = detailedReports.flatMap((form) => form.items);
            const itemsByOrder = allItems.reduce(
              (acc, item) => {
                const order = item.order ?? 0;
                if (!acc[order]) acc[order] = [];
                acc[order].push(item);
                return acc;
              },
              {} as Record<number, FormExcelItemDto[]>,
            );

            return Object.keys(itemsByOrder)
              .map(Number)
              .sort((a, b) => a - b)
              .flatMap((order) =>
                itemsByOrder[order]
                  .sort((a, b) => a.title.localeCompare(b.title))
                  .map((item) => item.title),
              );
          })();

    return createExportHandlers(
      detailedReports,
      (report) => normalizePunctualityReport(report, itemTitles),
      fileName,
      t,
    );
  }, [detailedReports, formType, fileName, t]);
};
